module.exports = __webpack_public_path__ + "static/media/location-you.1545ca0c.svg";